import React from 'react';
import Icon from '../../../components/AppIcon';

const CharacterStats = ({ character }) => {
  const stats = [
    { 
      label: 'Total Achievements', 
      value: character?.achievements?.total,
      icon: 'Trophy',
      color: 'var(--color-accent)'
    },
    { 
      label: 'Completed Raids', 
      value: character?.achievements?.raids,
      icon: 'Swords',
      color: 'var(--color-success)'
    },
    { 
      label: 'Quests Done', 
      value: character?.achievements?.quests,
      icon: 'ScrollText',
      color: 'var(--color-warning)'
    },
    { 
      label: 'Days Active', 
      value: character?.daysActive,
      icon: 'Calendar',
      color: 'var(--color-primary)'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 lg:gap-6">
      {stats?.map((stat, index) => (
        <div 
          key={index}
          className="bg-card rounded-xl p-4 md:p-5 lg:p-6 border border-border hover:shadow-warm-sm transition-all duration-250"
        >
          <div className="flex items-center gap-3 mb-2 md:mb-3">
            <div 
              className="w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center"
              style={{ backgroundColor: `${stat?.color}20` }}
            >
              <Icon name={stat?.icon} size={20} color={stat?.color} />
            </div>
          </div>
          <p className="text-2xl md:text-3xl lg:text-4xl font-bold mb-1">
            {stat?.value}
          </p>
          <p className="text-xs md:text-sm text-muted-foreground">
            {stat?.label}
          </p>
        </div>
      ))}
    </div>
  );
};

export default CharacterStats;